export default __webpack_public_path__ + "static/media/listen.802dbe5c.svg";